module.exports = __webpack_public_path__ + "assets/img/319ca5f23bf4b29ff5b72778240877e9.svg";